import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { comingBreadcrumbItems } from 'data/movement';
import ComingFilterMovements from './ComingFilterMovements';
import ComingFilterMovementsTable from './ComingFilterMovementsTable';
import './styles.scss';

const ComingOutMovements = () => {
  const { t } = useTranslation();
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [optionSenderId, setOptionSenderId] = useState(null);
  const [optionStatusId, setOptionStatusId] = useState(null);

  return (
    <div>
      <PageBreadcrumb items={comingBreadcrumbItems} />
      <div>
        <h2 className="mb-5">{t('incoming')}</h2>

        <ComingFilterMovements
          dateFrom={dateFrom}
          dateTo={dateTo}
          setDateFrom={setDateFrom}
          setDateTo={setDateTo}
          setOptionSenderId={setOptionSenderId}
          setOptionStatusId={setOptionStatusId}
          optionSenderId={optionSenderId}
          optionStatusId={optionStatusId}
        />
        <ComingFilterMovementsTable
          dateFrom={dateFrom}
          dateTo={dateTo}
          optionSenderId={optionSenderId}
          optionStatusId={optionStatusId}
        />
      </div>
    </div>
  );
};

export default ComingOutMovements;
